import { Component } from '@angular/core';
import { DataServiceService } from '../../services/data-service.service';

@Component({
  selector: 'app-bank',
  templateUrl: './bank.component.html',
  styleUrl: './bank.component.scss'
})
export class BankComponent {
  bankDataSource: any;
  constructor(private dataService: DataServiceService) {
    this.bankDataSource = dataService.getBankDataSource();
  }
}
